import React, {Component, Fragment} from 'react';
import {Route, Switch} from 'react-router-dom';

import App from './componets/App';
import LogInIndex from './componets/PageFull/LogIn';
import RegistroIndex from './componets/PageFull/Registro';
import RegistroDatosPersonalesIndex from './componets/PageFull/RegistroDatosPersonales';
import RecuperarIndex from './componets/PageFull/Recuperar';
import VerificarIndex from './componets/PageFull/Verificar';
import CambiarContrasenaIndex from './componets/PageFull/CambiarContrasena';
import CatalogosIndex from './componets/PageContent/Catalogos';
import SexoIndex from './componets/PageContent/Cat/Sexo';
import TipoUsuarioIndex from './componets/PageContent/Cat/TipoUsuario';
import MenuSubMenuIndex from './componets/PageContent/Cat/MenuSubMenu';
import RolesPermisosIndex from './componets/PageContent/Cat/RolesPermisos';
import UsuariosIndex from './componets/PageContent/Usuarios';
import HomeIndex from './componets/PageContent/Home';
import PerfilIndex from './componets/PageContent/Perfil';
import AcreditadosIndex from './componets/PageContent/Cliente';
import ExpedientesIndex from './componets/PageContent/Expedientes';
import ComentarioIndex from './componets/PageContent/Comentario';
import MonitorIndex from './componets/PageContent/Monitor';
import RepositorioDocumentosIndex from './componets/PageContent/RepositorioDocumentos';
import Page404Index from './componets/PageFull/Page404';
import EventListenerClickDom from './componets/Include/EventListenerClickDom/EventListenerClickDom';
import ClientesIndex from './componets/PageContent/Cliente';
import MatrizRiesgoIndex from './componets/PageContent/MatrizRiesgo';
import ReclamacionesIndex from './componets/PageContent/Reclamaciones';

class AppRoutes extends Component {
	
	render() {
		return (
			<Fragment>
				<EventListenerClickDom/>
				<App>
					<Switch>
						<Route exact path="/login" component={LogInIndex}/>
						<Route exact path="/registro" component={RegistroIndex}/>
						<Route exact path="/registrodatospersonales" component={RegistroDatosPersonalesIndex}/>
						<Route exact path="/recuperar" component={RecuperarIndex}/>
						<Route exact path="/verificar" component={VerificarIndex}/>
						<Route exact path="/cambiarcontrasena" component={CambiarContrasenaIndex}/>
						<Route exact path="/catalogo" component={CatalogosIndex}/>
						<Route exact path="/genero" component={SexoIndex}/>
						<Route exact path="/tipousuario" component={TipoUsuarioIndex}/>
						<Route exact path="/menus" component={MenuSubMenuIndex}/>
						<Route exact path="/rolespermisos" component={RolesPermisosIndex}/>
						<Route exact path="/usuario" component={UsuariosIndex}/>
						<Route exact path="/home" component={HomeIndex}/>
						<Route exact path="/perfil" component={PerfilIndex}/>
						<Route exact path="/acreditados" component={AcreditadosIndex}/>
						<Route exact path="/expedientes" component={ExpedientesIndex}/>
						<Route exact path="/comentario" component={ComentarioIndex}/>
						<Route exact path="/monitor" component={MonitorIndex}/>
						<Route exact path="/monitor" component={MonitorIndex}/>
						<Route exact path="/repositoriodocumentos" component={RepositorioDocumentosIndex}/>
						{/*<Route exact path="/clientes" component={ClientesIndex}/>*/}
						<Route exact path="/matrizriesgo" component={MatrizRiesgoIndex}/>
						<Route exact path="/reclamaciones" component={ReclamacionesIndex}/>
						<Route exact path="/" component={LogInIndex}/>
						<Route component={Page404Index}/>
					</Switch>
				</App>
			</Fragment>
		);
	}
}

export default AppRoutes;
